import type { UpdateResolver } from '@urql/exchange-graphcache'
import { invalidateCache } from '../utils/invalidateCache'

const inviteUsersUpdaters: Record<string, UpdateResolver> = {
    inviteManyUsers: (_parent, _args, cache) => {
        invalidateCache(cache, 'me')
    },
    inviteManyUsersWithDetails: (_parent, _args, cache) => {
        invalidateCache(cache, 'userByEmail')
    },
}

export { inviteUsersUpdaters }
